import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { UserAnimationPointDTO, UserAnimationPointYear } from '../../../models/user-animation-point-dto';
import { PollService } from '../../../services/poll.service';

@Component({
  selector: 'user-animation-sar-timeline',
  templateUrl: './user-animation-sar-timeline.component.html',
  styleUrls: ['./user-animation-sar-timeline.component.scss']
})
export class UserAnimationSarTimelineComponent implements OnInit {

  private static readonly PUMPKIN_YEAR = 2026;

  totalPointsSpent: number;
  totalPointsLost: number;
  totalPointsToLostThisYear: number = 0;
  pollFilled: boolean | null = null;
  pumpkinFound = false;
  /** Solo UI informativa al hover; no otorga puntos. */
  pumpkinPointsVisible = false;

  private readonly halloweenPollId = environment.halloweenPollId;

  constructor(
    private pollService: PollService,
    private toastr: ToastrService
  ) {
  }

  @Input() userPoints: UserAnimationPointDTO;

  ngOnInit(): void {
    this.getTotalPointsSpentLost();
    if (!this.halloweenPollId) {
      this.pollFilled = false;
      this.pumpkinFound = true;
      return;
    }
    this.pollService.getPollUserFilled(this.halloweenPollId).subscribe({
      next: (filled) => {
        this.pollFilled = filled;
        if (filled) {
          this.loadPumpkinFoundFromApi();
        }
      },
      error: () => {
        this.pollFilled = false;
      }
    });
  }

  private loadPumpkinFoundFromApi(): void {
    if (!this.halloweenPollId) {
      return;
    }
    this.pollService.getPollUser(this.halloweenPollId).subscribe({
      next: (pollUser) => {
        this.pumpkinFound = this.pollService.isPumpkinFoundInData(pollUser.Data);
      },
      error: () => {
        this.pumpkinFound = false;
      }
    });
  }

  private showPollPumpkinActive(): boolean {
    return !!this.halloweenPollId && this.pollFilled === true && !this.pumpkinFound;
  }

  showSpentExpand(pointYear: UserAnimationPointYear): boolean {
    return pointYear.PointsSpentYear.length > 0
      || (pointYear.Year === UserAnimationSarTimelineComponent.PUMPKIN_YEAR && this.showPollPumpkinActive());
  }

  showPollPumpkin(pointYear: UserAnimationPointYear): boolean {
    return pointYear.Year === UserAnimationSarTimelineComponent.PUMPKIN_YEAR && this.showPollPumpkinActive();
  }

  onPumpkinMouseEnter(): void {
    this.pumpkinPointsVisible = true;
  }

  onPumpkinMouseLeave(): void {
    this.pumpkinPointsVisible = false;
  }

  onPumpkinRewardClick(event: Event): void {
    event.stopPropagation();
    this.pumpkinPointsVisible = false;
    if (this.pumpkinFound || !this.halloweenPollId) {
      return;
    }
    this.pollService.markPumpkinFound(this.halloweenPollId).subscribe({
      next: () => {
        this.pumpkinFound = true;
        this.showPumpkinFoundToast();
      },
      error: () => {
        this.toastr.error('No se pudo registrar la calabaza. Inténtalo de nuevo.', '', {
          timeOut: 4000,
          positionClass: 'toast-top-right'
        });
      }
    });
  }

  private showPumpkinFoundToast(): void {
    const html = `
      <div class="toast-pumpkin-found__inner">
        <img class="toast-pumpkin-found__img" src="assets/images/encuestas/pumpkin.png" alt="" />
        <div class="toast-pumpkin-found__text">
          <p class="toast-pumpkin-found__title">¡CALABAZA CONSEGUIDA!</p>
          <p class="toast-pumpkin-found__message">ACABAS DE GANAR 10 PUNTOS EXTRA POR ARTE DE MAGIA</p>
        </div>
      </div>`;
    this.toastr.show(html, '', {
      enableHtml: true,
      toastClass: 'ngx-toastr toast-pumpkin-found',
      titleClass: 'toast-pumpkin-found__title-hidden',
      messageClass: 'toast-pumpkin-found__message-wrap',
      timeOut: 5000,
      positionClass: 'toast-pumpkin-top-right',
      closeButton: false,
      tapToDismiss: true
    });
  }

  getTotalPointsSpentLost() {
    this.totalPointsSpent = 0;
    this.totalPointsLost = 0;
    this.userPoints.PointYear.forEach(year => {
      this.totalPointsSpent += year.PointsSpent;
      this.totalPointsLost += year.PointsLost;
    });

    let lastYear = new Date().getFullYear() - 1;
    let lastYearData = this.userPoints.PointYear.find(x => x.Year == lastYear);
    if (lastYearData) {
      this.totalPointsToLostThisYear = lastYearData.PointsLeft;
    }
  }

}
